import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RequestCancellationService {
    private cancelRequests$ = new Subject<void>();

    get cancelRequests() {
        return this.cancelRequests$.asObservable();
    }

    cancelPendingRequests() {
        this.cancelRequests$.next(); // Émet un signal pour stopper les requêtes en cours
    }
}
